import * as React from "react";
import type { SVGProps } from "react";

interface BullyProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Bully = ({ cancelled = false, ...props }: BullyProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none" fillRule="evenodd">
      <path fill="#FFF" d="M16 6v3h6v7h-6v3H8v-3H2V9h6V6z" />
      <path
        fill="#E74D3D"
        d="M11.8 10.4a2.4 2.4 0 1 1 0 4.8 2.4 2.4 0 0 1 0-4.8"
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M16.1 4.7c-.77 0-1.4.63-1.4 1.4v3c0 .77.63 1.4 1.4 1.4h6c.77 0 1.4-.63 1.4-1.4v-.15l-.04-.15a1.4 1.4 0 0 0-1.36-1.1h-4.6V6.1c0-.77-.63-1.4-1.4-1.4m-8 0c.77 0 1.4.63 1.4 1.4v3c0 .77-.63 1.4-1.4 1.4h-6A1.4 1.4 0 0 1 .7 9.1v-.15l.04-.15A1.4 1.4 0 0 1 2.1 7.7h4.6V6.1c0-.77.63-1.4 1.4-1.4m8 15.8a1.4 1.4 0 0 1-1.4-1.4v-3c0-.77.63-1.4 1.4-1.4h6c.77 0 1.4.63 1.4 1.4v.15l-.04.15a1.4 1.4 0 0 1-1.36 1.1h-4.6v1.6c0 .77-.63 1.4-1.4 1.4m-8 0c.77 0 1.4-.63 1.4-1.4v-3c0-.77-.63-1.4-1.4-1.4h-6c-.77 0-1.4.63-1.4 1.4v.15l.04.15c.16.65.71 1.1 1.36 1.1h4.6v1.6c0 .77.63 1.4 1.4 1.4"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M16.1 5.45c.36 0 .65.3.65.65v2.35h5.35c.33 0 .6.24.64.55l.01.1c0 .36-.3.65-.65.65h-6a.65.65 0 0 1-.65-.65v-3c0-.36.3-.65.65-.65m-8 0c-.36 0-.65.3-.65.65v2.35H2.1c-.33 0-.6.24-.64.55l-.01.1c0 .36.3.65.65.65h6c.36 0 .65-.3.65-.65v-3c0-.36-.3-.65-.65-.65m8 14.3c.36 0 .65-.3.65-.65v-2.35h5.35c.33 0 .6-.24.64-.55l.01-.1c0-.36-.3-.65-.65-.65h-6c-.36 0-.65.3-.65.65v3c0 .36.3.65.65.65m-8 0a.65.65 0 0 1-.65-.65v-2.35H2.1a.65.65 0 0 1-.64-.55l-.01-.1c0-.36.3-.65.65-.65h6c.36 0 .65.3.65.65v3c0 .36-.3.65-.65.65"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Bully;
